import React, { useContext, useState } from "react";

import { CButton } from "@coreui/react";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";

import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import { elementToPDF } from "../../../../utils/export";
import Charts from "../../../Charts";
import LoadingStatistics from "../../../LoadingStatistics";
import StatisticFiltersCompare from "../../../StatisticFiltersCompare";
import "./styles.scss";
import { DataContext } from "../../Context/DataContext";

const formatAbility = (ability, ellipsis = false) => {
  const text = ability.description
    ? `${ability.code ? `(${ability.code}) ` : ""}${ability.description}`
    : "(Sem habilidade)";

  if (!ellipsis || text.length < 50) return text;

  return `${text.substring(0, 50)}...`;
};

const AcertosPorAssunto = ({ activity_id: activityId, infoUser, ...props }) => {
  const { dataAbility, loading, firstLoad, fetchData } =
    useContext(DataContext);
  const token = useSelector(state => state.user.token);

  const [data, setData] = dataAbility;

  const route = "statistics/evaluation_compare_unit_ability";

  const changeFilter = selected => {
    if (selected.groupId === 0) {
      return;
    }

    if (selected.regionId === 0 && !props.hideRegion) {
      toastr.warning("Atenção", "Preencha o regional");
      return;
    }

    if (selected.schoolId === 0 && !props.hideSchool) {
      toastr.warning("Atenção", "Preencha a escola");
      return;
    }

    if (selected.roomId === 0 && !props.hideRoom) {
      toastr.warning("Atenção", "Preencha a turma");
      return;
    }

    if (selected.userId === 0 && !props.hideUser) {
      toastr.warning("Atenção", "Preencha o usuário");
      return;
    }

    const params = {
      group_id: selected.groupId,
      region_id: props.hideRegion ? null : selected.regionId,
      school_id: props.hideSchool ? null : selected.schoolId,
      room_id: props.hideRoom ? null : selected.roomId,
      user_id: props.hideUser ? null : selected.userId,
      activity_id: activityId
    };

    fetchData(params, token, route, setData);
  };

  const getPercentage = (abilityId, type) => {
    if (!data[type] || !data.abilities) {
      return 0;
    }

    const correct =
      data[type].find(item => item.ability_id === abilityId && item.correct)
        ?.count || 0;
    const notCorrect =
      data[type].find(item => item.ability_id === abilityId && !item.correct)
        ?.count || 0;
    const total = correct + notCorrect;

    if (total === 0) {
      return 0;
    }

    return Math.round((correct / total) * 100);
  };

  return (
    <div className="d-flex flex-column align-items-center w-100">
      <div className="layoutTabelaComparacao flex-column w-100">
        <StatisticFiltersCompare
          activityId={activityId}
          onChange={changeFilter}
          hideUser={props.hideUser}
          hideRoom={props.hideRoom}
          hideSchool={props.hideSchool}
          hideRegion={props.hideRegion}
          infoUser={infoUser}
        />
      </div>
      <div className="w-100">
        {loading ? (
          <LoadingStatistics />
        ) : data?.abilities?.length > 0 && data ? (
          <div className="w-100">
            <div className="d-flex w-100 justify-content-end mt-3 mb-2">
              <CButton
                id="printBtn"
                color="link"
                className="text-muted p-0"
                size="sm"
                onClick={() =>
                  elementToPDF(
                    "toPrint",
                    props.hideRoom
                      ? "Escola x Habilidade.pdf"
                      : props.hideUser
                      ? "Turma x Habilidade.pdf"
                      : "Estudante x Habilidade.pdf"
                  )
                }
              >
                <i className="fa fa-file-pdf-o mr-2"></i> Exportar para PDF
              </CButton>
            </div>
            <div className="w-100" id="toPrint">
              <div className="management-1statistics layoutTabelaComparacao flex-column w-100 mb-4">
                <div className="row">
                  <div className="chart w-100">
                    <Charts
                      legendY="Habilidade"
                      legendX="Acertos %"
                      type="horizontalbar2"
                      title="Acertos por Habilidade"
                      data={{
                        labels: data.abilities.map(
                          ability => ability.code || "(Sem habilidade)"
                        ),
                        datasets: [
                          props.hideUser
                            ? null
                            : {
                                data: [
                                  ...data.abilities.map(ability =>
                                    getPercentage(ability.ability_id, "user")
                                  ),
                                  100
                                ],
                                label: "Estudante",
                                backgroundColor: "rgba(255, 99, 132, 0.2)",
                                borderColor: "rgba(255, 99, 132, 1)",
                                borderWidth: 1
                              },
                          props.hideRoom
                            ? null
                            : {
                                data: [
                                  ...data.abilities.map(ability =>
                                    getPercentage(ability.ability_id, "room")
                                  ),
                                  100
                                ],
                                label: "Turma",
                                backgroundColor: "rgba(54, 162, 235, 0.2)",
                                borderColor: "rgba(54, 162, 235, 1)",
                                borderWidth: 1
                              },
                          props.hideSchool
                            ? null
                            : {
                                data: [
                                  ...data.abilities.map(ability =>
                                    getPercentage(ability.ability_id, "school")
                                  ),
                                  100
                                ],
                                label: "Escola",
                                backgroundColor: "rgba(255, 206, 86, 0.2)",
                                borderColor: "rgba(255, 206, 86, 1)",
                                borderWidth: 1
                              },
                          props.hideRegion
                            ? null
                            : {
                                data: [
                                  ...data.abilities.map(ability =>
                                    getPercentage(ability.ability_id, "region")
                                  ),
                                  100
                                ],
                                label: "Regional",
                                backgroundColor: "rgba(75, 192, 192, 0.2)",
                                borderColor: "rgba(75, 192, 192, 1)",
                                borderWidth: 1
                              },
                          props.hideGroup
                            ? null
                            : {
                                data: [
                                  ...data.abilities.map(ability =>
                                    getPercentage(ability.ability_id, "group")
                                  ),
                                  100
                                ],
                                label: "Grupo",
                                backgroundColor: "rgba(153, 102, 255, 0.2)",
                                borderColor: "rgba(153, 102, 255, 1)",
                                borderWidth: 1
                              }
                        ].filter(item => item !== null)
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="w-100" style={{ marginBottom: "40px" }}>
                <table className="table table-hover table-outline mb-0 d-none d-sm-table w-100">
                  <thead className="thead-light">
                    <th>Habilidade</th>
                  </thead>
                  <tbody>
                    {data.abilities?.map((ability, index) => (
                      <tr>
                        <td>{formatAbility(ability)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : firstLoad ? (
          <div className="management-1statistics layoutTabelaComparacao flex-column w-100 mb-4">
            <div className="row">
              <div className="chart w-100">
                <div className="d-flex align-items-center justify-content-center w-100 p-5 text-muted text-center">
                  Selecione os filtros para pesquisar
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="management-1statistics layoutTabelaComparacao flex-column w-100 mb-4">
            <div className="row">
              <div className="chart w-100">
                <div className="d-flex align-items-center justify-content-center w-100 p-5 text-muted text-center">
                  Nenhuma aplicação da avaliação foi encontrada
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AcertosPorAssunto;
